var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.875V18.125C0.75 19.5781 1.92188 20.75 3.375 20.75H23.625C23.8125 20.75 24 20.9375 24 21.125C24 21.3594 23.8125 21.5 23.625 21.5H3.375C1.5 21.5 0 20 0 18.125V0.875C0 0.6875 0.140625 0.5 0.375 0.5C0.5625 0.5 0.75 0.6875 0.75 0.875ZM22.3594 5.65625L15.2344 12.7812C15.0938 12.9219 14.8594 12.9219 14.7188 12.7812L10.5 8.5625L4.73438 14.2812C4.59375 14.4219 4.35938 14.4219 4.21875 14.2812C4.07812 14.1406 4.07812 13.9062 4.21875 13.7656L10.2188 7.76562C10.3594 7.625 10.5938 7.625 10.7344 7.76562L15 11.9844L21.8438 5.14062C21.9844 5 22.2188 5 22.3594 5.14062C22.5 5.28125 22.5 5.51562 22.3594 5.65625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrowth);
export default __webpack_public_path__ + "static/media/icon_growth.cf800c1b299973bd2e2bc4c8bacc0e4b.svg";
export { ForwardRef as ReactComponent };